const { InnerBlocks, RichText } = wp.blockEditor;

const Save = ({ attributes }) => {
  const { title, margin } = attributes;

  return (
    <section className={`StreamingContent ${margin}`}>
      <div className="StreamingContent-Container">
        <RichText.Content
          tagName="h2"
          value={title}
          className="Typography title-4 center color-blue-dark margin-base"
        />

        <div className="StreamingContent-Swiper">
          <div className="swiper-wrapper">
            <InnerBlocks.Content />
          </div>
          <div class="swiper-button-next"></div>
          <div class="swiper-button-prev"></div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
    </section>
  );
};

export default Save;
